module.exports = __webpack_public_path__ + "img/tire_ai.a678f41c.png";